/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { safeJsonParse } from './safe_json_parse';

export type StorageType = 'session' | 'local';

export interface StorageSpecification {
	prefix?: string;
	type?: StorageType;
}

// This function is not explicitly exporting a type since it should always
// be this return value
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function storage<T extends Record<any, any>>(spec: StorageSpecification = {}) {
	const storeType: StorageType = spec.type ?? 'local';
	const store: Storage = storeType === 'local' ? globalThis.localStorage : globalThis.sessionStorage;

	return {
		storeType,

		get<K extends keyof T>(key: K): T[K] | null {
			const item = store.getItem(`${spec.prefix ?? ''}${key.toString()}`);
			if (!item) return null;

			return safeJsonParse<T[K]>(item);
		},

		set<K extends keyof T>(key: K, data: T[K]): void {
			store.setItem(`${spec.prefix ?? ''}${key.toString()}`, JSON.stringify(data));
		},

		removeItem<K extends keyof T>(key: K): void {
			store.removeItem(`${spec.prefix ?? ''}${key.toString()}`);
		},
	} as const;
}
